import { useMutation, useQueryClient } from "@tanstack/react-query";
import collectionApiClient from "../../../api/collection";

const useCreateCollectionLabelsBulkMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data: { texts: string[] }) => {
      return await collectionApiClient.createLabelsBulk(data);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["collection-labels"] });
    },
    onError: (error) => {
      console.error("Failed to create labels in bulk:", error);
    },
  });
};

export default useCreateCollectionLabelsBulkMutation;
